module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/H2-ee8420106dba89b361587921861cbd51.svg";